import Cookies from 'js-cookie';

import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';
import { getProcessEnvGlobalConfig } from '@shared/config/global';

export const zetalabsBlockchainInteroperability: Story = {
  id: 'zetalabs-blockchain-interoperability',
  type: 'CLASSIC',
  status: STATUS_TYPES.ACTIVE,
  name: 'Zetalabs Blockchain Interoperability',
  index: 0,
  content: {
    type: ACTION_TYPES.APP,
    bannerUrl: 'stories/1/main_banner.jpg',
    bannerMobileUrl: 'stories/1/main_banner_mobile.jpg',
    appId:
      Cookies.get('stories/1/appId') ||
      (getProcessEnvGlobalConfig('isDev') ? 'star-atlas' : 'zetalabs'),
    storyBlocks: [
      {
        bannerUrl: 'stories/1/story_banner_url_1.jpg',
        title: 'Project of the Month - ZetaLabs: Any Chain, Any Time',
        description:
          'Have you ever wished for a tool that allows you to seamlessly interact with any blockchain? This month, we shine the spotlight on ZetaLabs, a project that does just that and more.',
      },
      {
        bannerUrl: 'stories/1/story_banner_url_2.jpg',
        title: 'Break Down Blockchain Barriers',
        description:
          "Founded on the principle of interoperability, ZetaLabs serves as a gateway into ZetaChain's testnet. As a testing ground for various applications, ZetaLabs is on a mission to unify the blockchain universe.",
      },
      {
        bannerUrl: 'stories/1/story_banner_url_3.jpg',
        title: 'A New Frontier: Native Cross-Chain Swap App',
        description:
          'ZetaLabs makes swapping assets across different blockchains, including Bitcoin, as easy as a tap. Dive in and experience a revolution in liquidity and accessibility, powered by their native cross-chain swap app.',
      },
      {
        bannerUrl: 'stories/1/story_banner_url_4.jpg',
        title: 'On a Mission: Creating a Unified Blockchain Landscape',
        description:
          "With ZetaLabs, ZetaChain is making its mark in the blockchain landscape, placing interoperability at the forefront. It's not just about creating cutting-edge tools, but about fostering an interconnected, efficient, and versatile blockchain ecosystem.",
      },
      {
        bannerUrl: 'stories/1/story_banner_url_5.jpg',
        title: 'What’s Next?',
        description:
          "We're excited to watch ZetaLabs continue to break barriers and reshape the blockchain landscape. And we know you are too! Stay tuned on our platform for updates about their future breakthroughs and innovative projects.",
      },
    ],
  },
};
